module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-avatar', [(!_vm.isFailure) ? _c('v-icon', [_vm._v("check")]) : _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), (_vm.comm) ? _c('v-list-tile-content', [(_vm.comm.preferred_transport === "email") ? _c('v-list-tile-title', _vm._l((_vm.comm.recipient_emails), function(email) {
    return _c('span', {
      key: email
    }, [_vm._v(_vm._s(email))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.comm.preferred_transport === "sms") ? _c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(_vm.comm.recipient_phone_number))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n    " + _vm._s(_vm.status) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c530cc9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communications/CommunicationWatcher.vue
// module id = 1394
// module chunks = 9